import {
  Component,
  ChangeDetectionStrategy,
  Inject,
  OnInit,
  InputSignal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormDialog } from '@shared/models/form-dialog.model';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { ZFormGridComponent } from '../z-form-grid/z-form-grid.component';
import { NgIf } from '@angular/common';
import { ZButtonComponent } from '../z-button/z-button.component';
import { TranslatePipe } from '@ngx-translate/core';

type FormDialogData = FormDialog & { isEditMode: boolean };

@Component({
    selector: 'app-form-dialog',
    templateUrl: './form-dialog.component.html',
    styleUrls: ['./form-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ZDialogComponent, ZFormGridComponent, NgIf, ZButtonComponent, TranslatePipe]
})
export class FormDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormDialogData
  ) { }

  ngOnInit(): void {
    if (this.data.formGroup?.disabled) {
      this.data.formGroup.enable({ emitEvent: false });
      setTimeout(() => {
        this.data.formGroup?.disable({ emitEvent: false });
      }, 100);
    }
  }

  confirm() {
    const dialogValue = this.data.formGroup?.getRawValue();
    this.dialogRef.close(dialogValue);
  }
}
